<template>
    <v-dialog v-model="dialog" persistent scrollable max-width="50vw" >
      <v-btn color="secondary" dark slot="activator">
        <v-icon small>$vuetify.icons.rms_create</v-icon>
        {{ $t("rms.button.create") }}
      </v-btn>
      <v-card>
        <v-card-title class="px-4">
          <div class="title">Create Widget</div>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-0 px-0"
            small
            dark
            icon
            color="grey"
            @click.stop="reset()"
          >
            <v-icon small>$vuetify.icons.rms_close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 80vh">
            <v-form ref="form" onsubmit="return false;">
                <v-flex xs12 md6 lg12 class="px-2">
                    <!-- Widget Type -->
                    <v-select
                        class="mx-2"
                        outline
                        v-model="widget.type"
                        :items="widgetTypes"
                        :label="'Widget Type'"
                        item-text="text"
                        item-value="value"
                        hide-details
                        color="saSecondary"
                        prepend-inner-icon="$vuetify.icons.rms_agreement"
                    ></v-select>
                </v-flex>
                <v-flex xs12 md12 lg12 class="px-2 py-3">
                    <v-card elevation="2">
                        <v-card-title>
                            <v-tabs
                                background-color="transparent"
                                color="basil"
                                grow
                                v-model="widget_language"
                            >
                            <v-tab
                            v-for="language in enabledLanguages" :key="language.value"
                            >
                                {{ language.text }}
                            </v-tab>
                            </v-tabs>
                        </v-card-title>
                        <v-tabs-items v-model="widget_language">
                            <v-tab-item
                                v-for="language in enabledLanguages"
                                :key="language.value"
                            >
                            <v-card
                                color="basil"
                                flat
                            >
                                <v-card-text>
                                    <v-flex xs12 md6 lg12 class="px-2">
                                    <!-- Name -->
                                        <v-text-field
                                            class="mx-2"
                                            id="name"
                                            :label="$t('widget.save.form.name') + ' in ' + language.text"
                                            v-model="widget.name[language.value]" 
                                            :name="`title_${language.value}`"
                                            :rules="[
                                                rules.min_length(3),
                                                rules.max_length(255),
                                            ]"
                                            counter="255"
                                            color="primary"
                                            prepend-inner-icon="$vuetify.icons.rms_agreement"
                                            type="text"
                                            outline
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 class="px-2">
                                        <v-textarea outline
                                            :label="`Description in ${language.text}`"
                                            :name="`description_${language.value}`"
                                            v-model="widget.content[language.value]" 
                                            class="mx-2"
                                        />
                                    </v-flex>
                                </v-card-text>
                            </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card>
                </v-flex>
                <v-card-actions class="pa-3">
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" dark @click="createWidget">{{ $t('rms.button.create') }}</v-btn>
                </v-card-actions>
            </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>
  <script>
  import rules from "@/validation";
  import i18n from "@/i18n";
  import DEFINES from "@/defines";
  import { mapState, mapGetters } from "vuex";
  
  export default {
    name: "CreateWidget",
    data() {
      return {
        rules,
        dialog: false,
        loading:false,
        widget_language:null,
        languages:DEFINES.LOCALES,
        widget: this.initiateDefaultWidget()
      };
    },
    computed: {
      ...mapGetters("company", {
        selected_company_id: "getSelected",
        timezone: "getSelectedCompanyTimezone",
      }),
       ...mapState({
        films: (state) => state.film.selection_list,
        company: (state) => state.company.company,
      }),
      widgetTypes(){
        return Object.entries(DEFINES.WIDGETS.TYPES)
            .filter(type => !["10", "30"].includes(type[0]))
            .map(type => ({
                'value': parseInt(type[0]),
                'text': type[1]
            }));
        },
        enabledLanguages() {
            return DEFINES.LOCALES
        }
    },
    methods: {
        initiateDefaultWidget() {
            return {
                name : {
                    en : '',
                    es : '',
                    he : '',
                    ru : '',
                    it : ''
                },
                content : {
                    en : '',
                    es : '',
                    he : '',
                    ru : '',
                    it : ''
                },
                translations:DEFINES.WIDGET_LANGUAGES_DEFAULT_VALUES,
                related_to: DEFINES.WIDGETS.RELATED_TO_NETFEST,
                screener_ids: [],
                type: 0,
                published:false,
            }
        },
        async createWidget()
        {
            if (!this.$refs.form.validate()) {
                return false;
            }
            try {
                var response = await this.$store.dispatch("adminWidget/create", this.widget);
                this.$router.push({name: "AdminWidgetRoot", params:{widget_id:response.widget.id} });
                this.$store.dispatch("app/showMessage", {
                    message: i18n.t("widget.save.success.message"),
                    color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
                });
            } catch (error) {
                this.$store.dispatch("app/showMessage", {
                    message: error.message,
                    color: "error"
                });
            }
        },
        reset() {
            this.dialog = false;
            this.widget = this.initiateDefaultWidget();
        },
    },
  };
  </script>
  